import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import { SELLING_REJECTION_MAP } from "../../constants";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";
import { recordSignupTermination } from "../../utils/flowActivityUtils";

class SellingSorryPage extends Component {
  componentDidMount() {
    if (this.hasInitiated) return;
    this.hasInitiated = true;

    const reason = this.displayRejectionReason();
    if (reason) {
      recordSignupTermination(this.props.leadId, reason);
    } else {
      Sentry.captureMessage("SellingSorryPage rendered without sellingRejectionReason", {
        tags: { component: "SellingSorryPage" },
      });
    }
  }

  displayRejectionReason() {
    if (!this.props.sellingRejectionReason) return null;
    for (const [key, value] of this.props.sellingRejectionReason) {
      if (value) {
        return SELLING_REJECTION_MAP.get(key);
      }
    }
    return null;
  }

  render() {
    const rejectionReason = this.displayRejectionReason(); // something like "unregistered land"

    if (!rejectionReason) {
      return (
        <React.Fragment>
          <ScrollToTop />
          <Card title="We’re not able to help with this sale" removeTopPadding>
            <p>We’re sorry — this type of property sale falls outside what we’re currently able to help with.</p>
            <p>We wish you all the best with your move.</p>
          </Card>
          <Image src={imageOfficeWorking} fullWidth />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="We’re not able to help with this type of sale" removeTopPadding>
          <p>
            We specialise in standard residential conveyancing, and sales involving {rejectionReason} require specialist
            expertise that we’re not yet set up to offer.
          </p>
          <p>
            We’re sorry we can’t help you with this one. We hope that if your circumstances change in the future, you’ll
            consider Juno for your conveyancing.
          </p>
        </Card>
        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default SellingSorryPage;
